<template>
  <div>
    <!-- Quote Edit Form -->
    <div id="quote-edit">
      <invoices-edit-header ref="headerDetails" @header-validation="isValidHeader = !($event)" />
      <section class="quotes--quote-summary">
        <b-card>
          <div class="d-flex justify-content-between mb-2">
            <add-record
              v-if="checkClaim(CAN_ADD_SALES_ORDER)"
              :title="'Add Sales Order Item'"
              :fields="soLineFields"
              :gridId="addInvoiceGridId"
              :saveRecord="addToInvoice"
              :items="filteredSalesOrderLines"
              :navigationField="'partNumber'"
              :resetModal="resetModal"
              @updateCheckedRowItemIds="checkedSOLineItemIds = $event"
            class="mr-2" />
          </div>
          <b-row>
            <invoice-lines
              :invoiceId="invoiceId"
              :key="componentKey"
              @showEdit="onShowEdit"
              @showDelete="onDelete"
              @selectedInvoiceLine="setInvoiceLine"
            />
          </b-row>
        </b-card>
      </section>
      <b-tabs>
        <b-tab title="Summary" active>
          <b-row class="justify-content-between mt-2">
            <b-col cols="2">
              <div class="buttom-container">
                <div class="d-flex justify-content-between">
                  <a class="input-header-txt">Print Comments</a>
                </div>
                <lookup-dropdown
                  :options="printComments"
                  moduleName="printComments"
                  propKey="name"
                  resource="PrintComments"
                  lookupId="19"
                  class="mb-2"
                  @change="onPrintCommentChange"
                />
                <b-textarea rows="5" v-model.trim="invoice.comments" />
              </div>
              <div class="buttom-container mt-2">
                <b-form-group label="Internal Comments">
                  <b-textarea rows="5" v-model="invoice.internalComments" />
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="5">
              <b-tabs>
                <b-tab title="Summary" active>
                  <lower-summary-tab v-bind:quote="invoice" :page="'invoice-page'" isInvoiceView @credit-applied="onSaveToQbo" />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    Charges &nbsp;<b-badge variant="primary">{{ charges.length }}</b-badge>
                  </template>
                  <charges-list ref="invoiceCharge" :invoiceId="invoiceId" :salesOrderId="invoice.salesOrderId" :showInHouseOption="false" @updateCharge="onRefresh" />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    Expenses &nbsp;<b-badge variant="primary">{{ invoiceExpenseLines.length }}</b-badge>
                  </template>
                  <expense-lines :invoiceId="invoiceId" @updateExpense="onRefresh" />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    Payments &nbsp;<b-badge variant="primary">{{ invoicePaymentLines.length }}</b-badge>
                  </template>
                  <payments :invoiceObj="invoice" @updatePayment="onRefresh" />
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab v-if="!invoice.isProforma">
          <!--<template v-slot:title>
            Order Fulfillment <i :class="(fulfillmentData.isConfirmed) ? 'fa fa-check-circle' : 'fa fa-exclamation-triangle'" aria-hidden="true"></i>
          </template>-->

          <template v-slot:title>
            Order Fulfillment <i class="fa fa-check-circle" aria-hidden="true" v-if="fulfillmentData.isConfirmed" style="color:green"></i> <i class="fa fa-check-circle" aria-hidden="true" v-else style="color:red"></i>
          </template>

          <span v-if="!shippingFulFillmentLoad"><i class="fa fa-spinner fa-pulse fa-fw"> </i> Loading Fulfillment</span>
          <order-fulfillment isShipping v-if="shippingFulFillmentLoad" :companyId="invoice.companyId" :invoiceFulfillment="fulfillmentData"
            @onFulfillmentChange="fulfillmentData = $event" />
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_INVENTORY) && !invoice.isProforma">
          <template v-slot:title>
            Pick Tickets &nbsp;<b-badge variant="primary">{{ pickTicketLinesByInvoiceLine.length }}</b-badge>
          </template>
          <pick-ticket-lines-tab :invoiceLineId="invoiceLine.id" />
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_INVENTORY) && !invoice.isProforma">
          <template v-slot:title>
            Received Items &nbsp;<b-badge variant="primary">{{ allocationsList.length }}</b-badge>
          </template>
          <allocations-tab :salesOrderLineId="invoiceLine.salesOrderLineId" hideAction />
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_ALL_SALES_ORDERS)">
          <template v-slot:title>
            Sales Orders &nbsp;<b-badge variant="primary">{{ salesOrdersCustom.length }}</b-badge>
          </template>
          <sales-orders :dataBy="'salesOrder'" :salesOrderLineId="invoiceLine.salesOrderLineId" :gridId="soLineGridId" />
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_ALL_QUOTE)">
          <template v-slot:title>
            Quotes &nbsp;<b-badge variant="primary">{{ quotesFiltered.length }}</b-badge>
          </template>
          <quotes :quoteLineId="invoiceLine.quoteLineId" isQuoteTab />
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_ALL_REQUIREMENTS)">
          <template v-slot:title>
            Requirements &nbsp;<b-badge variant="primary">{{ filteredRequirement.length }}</b-badge>
          </template>
          <requirements :requirementLineId="invoiceLine.requirementLineId" />
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_ALL_RMAS) && !invoice.isProforma">
          <template v-slot:title>
            RMAs  &nbsp;<b-badge variant="primary">{{ rmaLinesByFilter.length }}</b-badge>
          </template>
          <crma-tab :invoiceLineId="invoiceLine.id" :invoiceId="invoiceId" isRmaAsTab />
        </b-tab>
        <b-tab v-if="!invoice.isProforma">
          <template v-slot:title>
            CAR/SCAR  &nbsp;<b-badge variant="primary">{{ correctiveActionReportsList.length }}</b-badge>
          </template>
          <CarScarReports :invoiceLineId="invoiceLine.id" :otherData="{invoiceId:invoiceId,companyId:invoice.companyId,companyName:invoice.companyName,}" />
        </b-tab>
        <b-tab title="Documents and Images" v-if="!invoice.isProforma">
          <documents-and-images :reference="'invoiceLineId'" :refId="invoiceLine.id" :partId="invoiceLine.partId" />
        </b-tab>
      </b-tabs>
      <div class="d-flex justify-content-between mt-2">
        <div></div>
        <div class="mr-3">
          <b-button type="button" variant="secondary" size="sm" @click="onCancel" v-if="checkClaim(CAN_VIEW_ALL_INVOICES)">Exit</b-button>
          <b-button :variant="invoice.qbTxnID ? 'success' : 'primary'" type="submit" class="ml-2" size="sm" @click="onSaveToQbo"
                    v-if="checkClaim(CAN_EDIT_INVOICES) && isQboActive" :disabled="isQboLoading">
                    <i v-show="isQboLoading" class="fa fa-spinner fa-pulse fa-fw"></i>
                    {{ invoice.qbTxnID == null ? 'Publish' : 'Sync' }} to Quickbooks
          </b-button>
          <b-button variant="primary" type="submit" class="ml-2" size="sm" @click="onSave(false)" :disabled="isSaving" v-if="checkClaim(CAN_EDIT_INVOICES)">
            <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save and Continue
          </b-button>
          <b-button variant="primary" type="submit" class=" ml-2" size="sm" @click="onSave(true)" :disabled="isSaving" v-if="checkClaim(CAN_EDIT_INVOICES) && checkClaim(CAN_VIEW_ALL_INVOICES)">
            <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save and Exit
          </b-button>
          <b-button
            v-if="checkClaim(CAN_AUTHORIZE_INVOICES)"
            :variant="invoice.isAuthorized ? 'success' : 'danger'"
            size="sm"
            class="ml-2"
            :disabled="isSaving"
            @click="onAuthorize"
          >
            <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>{{ invoice.isAuthorized ? 'Unauthorize' : 'Authorize' }}
          </b-button>

          <b-button variant="primary" size="sm" @click="onEmailQuote" class="ml-2" :disabled="!invoice.isAuthorized">
            <i v-show="isEmailLoading" class="fa fa-spinner fa-pulse fa-fw"></i> Send Email
          </b-button>
          <send-emails :sendEmailData="sendEmailData" @refresh="onRefresh"></send-emails>
          <!-- <b-button variant="primary" size="sm" @click="$bvModal.show('view-fast-report')" class="ml-2" :disabled="!invoice.isAuthorized">
            <i v-show="isPrintLoading" class="fa fa-spinner fa-pulse fa-fw"></i> Print
          </b-button> -->
        </div>
      </div>
    </div>

    <!-- Part Modal -->
    <div id="add-part-popup" class="d-inline pull-left">
      <b-modal id="add-part-modal" ref="add-part-modal" size="xl" scrollable>
        <template slot="modal-header">
          <h5 class="modal-title">Edit Line Detail</h5>
        </template>
        <line-details
          ref="editLineDetails"
          :lineObj="invoiceLine"
          @lineChange="onLineChange"
          invoiceView
          invoiceLineView
          priceOnly
          showMaxQty
          @line-validation="isLineInvalid = $event"
        />
        <template slot="modal-footer">
          <b-button @click="$bvModal.hide('add-part-modal')">Cancel</b-button>
          <b-button v-if="checkClaim(CAN_EDIT_INVOICES)" class="mr-2" variant="primary" @click="savePartForm" :disabled="isSavingLine">
            <i v-if="isSavingLine" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save</b-button>          
        </template>
      </b-modal>
      
      <!-- <b-modal id="view-report-modal" ref="view-report-modal" hide-footer>
        <report-viewer :filePath="'ReportsRoot/Invoice.flxr'" :parameter="{ Invoice: invoiceId }" :reportName="'Invoice'" />
      </b-modal> -->

      <!-- <report-viewer :parameter="{Invoice: invoiceId}" :reportFileName= "!invoice.isProforma ? null : 'ProFormaInvoice'" :reportName="!invoice.isProforma ? 'Invoice': 'SalesOrder - ProFormaInvoice'" /> -->
      <!-- <fast-report-viewer :parameter="invoiceId" :moduleName="'Invoices'" /> -->
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
  import { GRID_ID, REPORTS_CONSTANTS } from '@/shared/constants';
  import RequirementDetails from '@/shared/components/RequirementDetails/index';
  import LineDetails from '@/shared/components/LineDetails/index';
  import InvoiceLines from '@/pages/Invoices/components/InvoiceLines';
  import InvoicesEditHeader from '@/pages/Invoices/components/edit/components/InvoicesEditHeader';
  import InvoiceSummary from '@/pages/Invoices/components/edit/components/InvoiceSummary';
  import Charges from '@/pages/Quotes/components/EditQuote/components/Charges';
  import PartForm from '@/shared/components/Parts';
  //import Sources from '@/shared/components/Sources';
  // import Offers from '@/shared/components/Offers';
  import Requirements from '@/shared/components/Requirements';
  //import InventoryList from '@/shared/components/InventoryList';
  import ItemRequirements from '@/shared/components/ItemRequirements/index';
  import ChargesList from '@/pages/Invoices/components/InvoiceCharges';
  import AddRecord from '@/shared/components/AddRecord';
  import Sources from '@/shared/components/Sources';
  //import PurchaseOrders from '@/shared/components/PurchaseOrders';
  import OrderFulfillment from '@/shared/components/OrderFulfillment';
  import Quotes from '@/shared/components/Quotes';
  import SalesOrders from '@/shared/components/SalesOrders';
  import AllocationsTab from '@/shared/components/Allocations/Allocated';
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css';
  import LowerSummaryTab from '@/shared/components/LowerSummaryTab';
  import SendEmails from '@/shared/components/SendEmails/index';
  import reportApi from '@/resources/reportApi';
  import soLineFields from '../add/fields';
  import ReportViewer from '@/shared/components/ReportViewer';
  import DocumentsAndImages from '@/shared/components/DocumentsAndImages';
  import CarScarReports from '@/shared/components/CarScarReports';
  import CrmaTab from '@/pages/Customerrmas/components/CustomerrmasLines'
  import PickTicketLinesTab from '@/shared/components/PickList/components/PickTicketLines';
  import FastReportViewer from '@/shared/components/FastReportViewer';
  import Payments from '@/shared/components/Payments';
  import ExpenseLines from '@/shared/components/ExpenseLines';

  export default {
    components: {
      InvoiceLines,
      InvoicesEditHeader,
      RequirementDetails,
      LineDetails,
      InvoiceSummary,
      LowerSummaryTab,
      Charges,
      ChargesList,
      Requirements,
      ItemRequirements,
      PartForm,
      // InventoryList,
      Sources,
      //PurchaseOrders,
      OrderFulfillment,
      Quotes,
      SalesOrders,
      AllocationsTab,
      swiper,
      swiperSlide,
      AddRecord,
      SendEmails,
      ReportViewer,
      DocumentsAndImages,
      CarScarReports,
      CrmaTab,
      PickTicketLinesTab,
      FastReportViewer,
      Payments,
      ExpenseLines
    },
    metaInfo() {
      return {
        title: `${this.invoice.isProforma ? 'Proforma' : 'Invoice'}: ${this.invoiceId} - ${this.invoice.companyName}`,
      }
    },
    data() {
      return {
        soLineFields,
        mergedObj: {},
        componentKey: 0,
        showAllGridRows: false,
        soLineGridId: GRID_ID.SALES_ORDER_LINES_TAB_GRID,
        partIds: [],
        partId: 0,
        selectedCompany: 0,
        // company: {},
        fullAddressString: '',
        address: '',
        invoiceLine: {},
        cloneQuoteLine: {},
        //marginPercent: '',
        isPrintLoading: false,
        isEmailLoading: false,
        selectedAccount: {},
        filterValObj: {
          id: null,
          companyId: null,
          contactId: null,
        },
        chosenName:  '',
        addQuoteFields: [],
        checkedSOLineItemIds: [],
        sendEmailData:{},
        fulfillmentData: {},
        shippingFulFillmentLoad: false,
        isQboLoading: false,
        isSaving: false,
        addInvoiceGridId: GRID_ID.INVOICE_ADD_GRID,
        isSavingLine: false,
        isLineInvalid: false,
        isValidHeader: false
      };
    },
    computed: {
      ...mapGetters('expenseLines', ['invoiceExpenseLines']),
      ...mapState('pickTicket', ['pickTicketLinesByInvoiceLine']),
      ...mapGetters('inventory', ['allocationsList']),
      ...mapGetters('salesOrders', ['salesOrdersCustom']),
      ...mapState('invoices', ['invoice', 'charges']),
      ...mapGetters('quotes', ['quotesFiltered']),
      ...mapGetters('customerRmasLines', ['rmaLinesByFilter']),
      ...mapGetters('requirements', [ 'filteredRequirement' ]),
      ...mapGetters('carScarReports', { correctiveActionReportsList: 'gridList' }),
      ...mapGetters('receivePayments', ['invoicePaymentLines']),
      ...mapGetters('quickBooks', ['qboSettingState']),
      // ...mapGetters('quoteAdd', [
      //   'customers',
      //   'contacts'
      // ]),
      ...mapGetters('lookup', [
        'printComments',
      ]),
      ...mapGetters('salesOrderLines', ['filteredSalesOrderLines']),
      ...mapState('invoiceLines', ['invoiceLines']),
      ...mapGetters('parts', ['documentsLists']),
      ...mapGetters('companies', ['companyById']),
      //...mapGetters('companies', ['company']),
      invoiceId() {
        return parseInt(this.$route.params.id);
      },
      companyId() {
        return this.$route.params.companyId;
      },
      reportOption() {
        return (this.invoice.isProforma) ? REPORTS_CONSTANTS.filter(x => x.report == 'SalesOrder_Proforma') : REPORTS_CONSTANTS.filter(x => x.module == 'Invoices');
      },
      company() {
        var result = this.companyById(this.invoice.companyId);
        return result;
      },
      isQboActive() {
        return this.qboSettingState && this.qboSettingState.value == "1";
      }
    },
    methods: {
      ...mapActions('invoices', { getInvoiceById: 'getById' }),
      ...mapActions('invoiceLines', [
        'getInvoiceLines',
        'updateInvoiceLine',
        'deleteInvoiceLine'
      ]),
      ...mapActions('invoices', ['updateInvoice',
       'addInvoiceWithMultipleSOLines',
       'getInvoiceFulfillment',
       'saveInvoiceWithFulfillment',
       'authorizeInvoice',
       'saveToQuickbooks']),
      ...mapActions('companies', { getCompanyById: 'getById', getByNameAndAccountType: 'getByNameAndAccountType' }),
      // ...mapActions('quoteAdd', [
      //   'getCustomers',
      //   'getContacts',
      // ]),
      ...mapMutations('quoteAdd', {quoteAddSetItem: 'setItem'}),
      ...mapActions('salesOrderLines', [ 'getAllocatedByCompanyId' ]),
      ...mapActions('shippingAccount', ['getShippingAccounts']),
      ...mapActions('receivePayments', ['getPaymentLinesByInvoice']),
      // ...mapMutations('salesOrderLines', [ 'clearSalesOrderLinesByCompany', 'filterLinesByContactId' ]),
      ...mapMutations('salesOrderLines', [ 'filterLinesByContactId' ]),
      setInvoiceLine(invoiceLine) {
        this.invoiceLine = invoiceLine;
      },
      async onSaveToQbo() {
        try {
          if (this.isQboActive) {
            this.isQboLoading = true;
            const result = await this.saveToQuickbooks(this.invoiceId);

            if (result.status == 200) {
              this.$snotify.success('Successfully saved to Quickbooks');
            }
            // this.onRefresh();
            this.isQboLoading = false;  
          }          
        }catch (e) {
          this.isQboLoading = false;
          /*console.log(e.message);*/
        }
      },
      async onAuthorize() {
        if (this.invoice.isAuthorized) {
          await this.onSave(false, !this.invoice.isAuthorized);
        } else {
          await this.$refs.headerDetails.getHeaderValidation();
          if (this.isValidHeader) {
            await this.onSave(false, !this.invoice.isAuthorized);
          }
        }
      },
      async savePartForm() {
        await this.$refs.editLineDetails.getLineValidation();
        console.log(this.isLineInvalid, "Is Line INvalid")
        if (!this.isLineInvalid) {
          this.isSavingLine = true;
          this.mergedObj = {
            ...this.mergedObj,
            invoiceId: this.invoiceLine.invoiceId,
            id: this.invoiceLine.id
          };
          await this.updateInvoiceLine(this.mergedObj);
          this.isSavingLine = false;
          this.$bvModal.hide('add-part-modal');
          this.$snotify.success('Line Updated Successfully', 'Invoice Line');
          this.onRefresh();
        }
        
      },
      async handleOk(bvModalEvt) {
        //console.log(this.quoteLine);

        try {
          const result = await this.updateQuoteLine(this.quoteLine);
          //console.log('update quoteline', result);
          this.updateTotal(result.quoteSummary);
        } catch {
        } finally {
          this.onRefresh();
        }
        //console.log('handleOk',bvModalEvt,this.quoteLine);

        // Prevent modal from closing
        //bvModalEvt.preventDefault()
        // Trigger submit handler
        //this.handleSubmit()
      },
      async onEmailQuote() {
        //subject:`Invoice: ${this.invoiceId} - ${this.invoice.companyName}`,
        this.sendEmailData = {
          template: 'Invoice',
          source: 'Invoice',
          to:this.invoice.contactEmail,
          ReferenceId: (this.invoice.isProforma) ? this.invoice.salesOrderId : this.invoiceId,
          reportSelectionOptions: this.reportOption,
          documentsSelection: this.documentsLists,
        }
        this.$root.$emit('bv::show::modal', 'send-email-modal');
      },

      updateTotal(emit) {
        //console.log('updating totals');
        //console.log(emit);
        if (emit) {
          this.quote.total = Number(emit.total).toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2 });
          this.quote.subTotal = Number(emit.subTotal).toLocaleString();
          this.quote.gpMargin = emit.gpMargin;
          this.quote.grossProfit = Number(emit.grossProfit).toLocaleString();
          this.quote.totalCharges = Number(emit.charges).toLocaleString();
        }
      },
      async initializeModal() { },
      setQuoteline(quoteLine) {
        this.quoteLine = JSON.parse(JSON.stringify(quoteLine));
        this.cloneQuoteLine = quoteLine;
        //this.marginPercent = this.profit / this.totalPrice * 100;
      },
      onShowEdit(invoiceLine) {
        this.invoiceLine = invoiceLine;

        this.$refs['add-part-modal'].show();
      },
      async onDelete(invoiceLine) {
        const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete this Invoice Line Id: ${invoiceLine.id}?`});
        if (deleteConfirmed) {
          await this.deleteInvoiceLine({
            id: this.invoiceId,
            lineId: invoiceLine.id
          }).then(() => {
            this.$snotify.success('Invoice Line Deleted Successfully', 'Invoice Line');
            this.onRefresh();
          });
        }
      },
      resetModal() {
        this.$bvModal.hide('add-part-modal');
      },
      onPrintCommentChange({ text, name }) {
        this.invoice.comments = (this.invoice.comments) ? this.invoice.comments + '\n' + (text || name) : (text || name);
      },
      onAddPart() {
        this.$bvModal.show('add-part-modal');
      },
      onCancel() {
        this.$router.push({ name: (this.invoice.isProforma) ? 'proforma-invoices' :'invoices' });
      },
      onPaymentUpdated() {
        this.onRefresh();
        this.getPaymentLinesByInvoice(this.invoice.id);
      },
      async onRefresh() {
        await this.onSave(false);
        this.getInvoiceById(this.invoiceId);
        this.componentKey += 1;
      },
      async chgPartId(part) {
        //alert(part.id);
        eventBus.$emit('chgPartId', this.part);
        this.partId = part.id;
      },
      async addPart(part) {
        if (part.Id == 0) return;
        this.quoteLine = {
          id: 0,
          quoteId: this.quoteId,
          partId: part.id,
          buyerPrice: part.buyerPrice,
          price: part.price,
          quantity: part.quantity,
        };
        try {
          await this.createQuoteLine(this.quoteLine);
        } catch {
        } finally {
          this.onRefresh();
        }
      },
      async onSave(exit, isAuthorize = false) {
        await this.$refs.headerDetails.getHeaderValidation();
        if (this.isValidHeader) {
          try {
            this.isSaving = true;
            const result = await this.saveInvoiceWithFulfillment({
              data: {
                invoiceData: this.invoice,
                fulfillmentData: this.fulfillmentData
              },
              isAuthorize
            });
            this.isSaving = false;
            if (result.status == 200) {
              this.$snotify.success(`Invoice saved succesfully`);
              this.onSaveToQbo();
              if (exit) {
                this.$router.push({name: 'invoices'});
              }
              this.getFulfillment();
            }
            
          }catch (e) {
            this.isSaving = false;
            /*console.log(e.message);*/
          }
        }
      },
      onLineChange(lineObj) {
        this.mergedObj = {
          ...this.mergedObj,
          ...lineObj
        };
      },
      async addToInvoice() {

        console.log('innnn');

        var invoiceData = await this.addInvoiceWithMultipleSOLines({
          invoiceId: this.invoiceId,
          salesOrderLineIdList: this.checkedSOLineItemIds
        });

        console.log('invoiceData :', invoiceData);

        if (invoiceData != null) {
          this.$snotify.success('Invoice Saved Successfully', 'Invoice');
          await this.getInvoiceLines(this.invoiceId);
          this.onRefresh();
        }
      },
      async printReport() {
        try {
          this.isPrintLoading = true;
          const {data} = await reportApi.get("api/report/ProFormaInvoice/" + this.invoiceId, {
            name: 'document',
            responseType: 'blob'
          });

          const fileUrl = URL.createObjectURL(data);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          a.href = fileUrl;
          a.download = `ProFormaInvoice.pdf`;
          a.click();
          window.URL.revokeObjectURL(fileUrl);
          document.body.removeChild(a);
          this.isPrintLoading = false;
        }catch (e) {
          this.isPrintLoading = false;
          /*console.log(e.message);*/
        }
      },
      async getFulfillment() {
        if (this.invoiceId != null)
        {
          this.fulfillmentData = await this.getInvoiceFulfillment({
            companyId: this.invoice.companyId,
            invoiceId: this.invoiceId
          });

          console.log('this.fulfillmentData :', this.fulfillmentData);


          if (this.fulfillmentData.invoiceId == 0) {
            this.fulfillmentData.invoiceId = this.invoiceId;
          }

          this.shippingFulFillmentLoad = true
        }
      }
    },
    watch: {
      'filterValObj.contactId'(contactId) {
        this.checkedSOLineItemIds = [];
        this.filterLinesByContactId(contactId);
      }
      // async invoiceLine() {
      //   await this.reloadDocuments();
      // }
    },
    async mounted() {
      this.setContainerLoader(true);
      await this.getInvoiceById(this.invoiceId).then(async () => {
        this.setContainerLoader(false);
        this.getFulfillment();
        if (this.invoice.companyId) {
          this.getShippingAccounts(this.invoice.companyId);
          this.getAllocatedByCompanyId(this.invoice.companyId);
          if (Object.keys(this.company).length == 0) {
            this.getCompanyById(this.invoice.companyId);
          }
        }
      }).catch(() => {
        this.setContainerLoader(false);
        //return back to listing page because error in fetch record
        this.$router.push({name: 'invoices'});
      });
      if('openCharge' in this.$route.query) {
        this.$refs['invoiceCharge'].openChargesModal();
      }
    },
  };
</script>

<style lang="scss">
  .quotes--quote-summary {
    .first-row {
      margin-bottom: 15px;
    }

    .add-part {
      margin-right: 15px;
    }
  }

  .buttom-container {
    margin-left: 5px;
  }

  .tree-list {
    width: 500px;
  }
</style>
